import { render, staticRenderFns } from "./twoo.vue?vue&type=template&id=cdb9d61e&scoped=true"
import script from "./twoo.vue?vue&type=script&lang=js"
export * from "./twoo.vue?vue&type=script&lang=js"
import style0 from "./twoo.vue?vue&type=style&index=0&id=cdb9d61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb9d61e",
  null
  
)

export default component.exports